import styled, { keyframes, css } from 'styled-components';
import { shapes, scrollerTypes } from '.';
import Button from '../Button';

export const ScrollerButton = styled(Button)`
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: var(--spacing-16);
  right: var(--spacing-16);
  z-index: 3;
`;

export const Frame = styled.div<{ shape?: shapes; type: scrollerTypes }>`
  aspect-ratio: var(--ratio);
  align-items: center;
  display: flex;
  overflow: hidden;
  position: relative;
  transition: width 0.6s cubic-bezier(0.75, 0, 0.25, 1);
  transition-delay: 0.4s;
  will-change: width;
  width: var(--width);

  ${({ type }) =>
    type === 'double' &&
    `
          flex-shrink: 0;
          border-radius: var(--radius-md);
      `}

  ${({ shape }) =>
    shape === 'round' &&
    `
          border-radius: 100%;
          grid-row:span 2;
      `}
    ${({ shape }) =>
    shape === 'vertical' &&
    `
          grid-row:span 2;
      `}
    ${({ shape }) =>
    shape === 'horizontal-pill' &&
    `
          border-radius: var(--radius-full);
          grid-row:span 1;
      `}
    ${({ shape }) =>
    shape === 'horizontal' &&
    `
          grid-row:span 1;
      `}
    ${({ shape }) =>
    (shape === 'vertical' || shape === 'horizontal') &&
    `
          border-radius: var(--radius-md);
      `}

    & > picture,
    & img,
    & > video {
    block-size: 100%;
    inline-size: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.75, 0, 0.25, 1);
    will-change: transform;
  }

  @media (hover: hover) {
    &:has(video):hover,
    &:is(a):hover {
      cursor: pointer;
      width: calc(var(--width) * 1.2);

      > picture,
      > img,
      > video {
        transform: scale(1.05);
      }
    }
  }
`;

const marqueeAnimation = ({ pos, speed }) => {
  const animation = keyframes`
    from {
      transform: translateX(${pos.from}); 
    }
    to { 
      transform: translateX(${pos.to}); 
    }
  `;

  return css`
    animation: ${animation} ${speed}s linear infinite;
  `;
};

export const ItemWrap = styled.div`
  display: flex;
  gap: var(--spacing-16);
`;

export const ScrollerWrapper = styled.div<{ type: scrollerTypes }>`
  display: flex;
  gap: var(--spacing-16);
  overflow: hidden;
  white-space: nowrap;
  flex-wrap: nowrap;

  ${({ type }) =>
    type === 'double' &&
    `
        &:nth-child(1) > :nth-child(1) > * {
          align-items: end;
        }
        &:nth-child(2) > :nth-child(1) > * {
          align-items: start;
        }
    `}
`;

export const MarqueeWrapper = styled.div`
  ${marqueeAnimation};
  display: flex;
  gap: var(--spacing-16);

  &:hover {
    animation-play-state: paused;
  }
`;
